module.exports = __webpack_public_path__ + "static/media/anpost-commerce.99200e64.png";